import { render } from "./typeTestDrive.vue?vue&type=template&id=7e9d74f3"
import script from "./typeTestDrive.vue?vue&type=script&lang=js"
export * from "./typeTestDrive.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__